// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalHeader_header__0q5js","title":"ModalHeader_title__TOvlu","description":"ModalHeader_description__IEeqr"};